/**
 * Created by tofael on 10/20/17.
 */
import React from 'react';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';

const SipCredentialsDialog = ({open, sip_id, sip_password, onChange, onUpdate, toggleSipDialog}) => {

  const actions = [
    <FlatButton
      label="Update"
      primary={true}
      keyboardFocused={true}
      onTouchTap={onUpdate} />,
    <FlatButton
      label="Cancel"
      onTouchTap={toggleSipDialog} />
  ];

  return (
    <div>
      <Dialog
        open={open}
        modal={false}
        actions={actions}
        title="Update SIP credentials"
        onRequestClose={toggleSipDialog.bind(null, false, '')} >
        <TextField
          hintText="Enter sip id"
          floatingLabelText="Sip ID"
          value={sip_id}
          onChange={onChange.bind(null, 'sip_id')}/><br/><br/>
        <br/>
        <TextField
          hintText="Enter sip password"
          floatingLabelText="SIP Password"
          fullWidth={true}
          value={sip_password}
          onChange={onChange.bind(null, 'sip_password')}/><br/><br/>
      </Dialog>
    </div>
  );
};

export default SipCredentialsDialog;


// WEBPACK FOOTER //
// ./src/screens/profile/doctor/sip-credentials.js